module.exports = __webpack_public_path__ + "img/certificate.6648d3cb.jpg";